import React from 'react';
import { NavLink } from 'react-router-dom';

export default props => {
    return (
        <div className="container-fluid no-print app-header">
            <div className="row align-items-center">
                <div className="col-lg-4 col-md-12">
                    <img
                        className="img-fluid header-image"
                        src="../images/logo_cluster.png"
                        alt="First Coast Home Pros"
                    />
                </div>

                <div className="col-lg-8 col-md-12">
                    <nav className="top-nav">
                        {/*<NavLink*/}
                        {/*    exact*/}
                        {/*    to="/RevenueBoard"*/}
                        {/*    className="top-nav-link"*/}
                        {/*    activeClassName="active"*/}
                        {/*>*/}
                        {/*    Revenue Board*/}
                        {/*</NavLink>*/}

                        {/*<NavLink*/}
                        {/*    exact*/}
                        {/*    to="/CancellationList"*/}
                        {/*    className="top-nav-link"*/}
                        {/*    activeClassName="active"*/}
                        {/*>*/}
                        {/*    Cancellation List*/}
                        {/*</NavLink>*/}
                    </nav>
                </div>
            </div>
        </div>
    );
};